<template>
  <div>
    <v-card
      flat
      :loading="loading"
      class="tab-details"
    >
      <v-progress-linear
        v-if="loading"
        indeterminate
        color="primary"
      ></v-progress-linear>
      <v-card-text>
        <div class="mx-12 text-h6 font-weight-black mt-3 text-c-green">
          {{ local.caseFile.tabHeaders.documents }}
        </div>
        <v-row class="mx-12">
          <template v-for="(item, index) in documents">
            <v-col
              :key="index"
              cols="4"
            >
              <document-card
                :document="item"
                :case-object-key="caseObjectKey"
                :is-pega="isPega"
                @document-card-click="openDocumentsInfo(item)"
              ></document-card>
            </v-col>
          </template>
          <v-col cols="12">
            <naj-no-data
              :has-data="documents && documents.length > 0"
              :loading="loading"
            ></naj-no-data>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <degree-color-palette></degree-color-palette>

    <show-documents-model
      :documents="documents"
      :selected-documents-index-prop="selectedDocumentIndex"
      :modal-visibility="showDocumentsInfoModal"
      @modalClose="closeDocumentsInfo"
    ></show-documents-model>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DocumentCard from '../../../../global/components/cards/document-card.vue';
import ShowDocumentsModel from '../../../../cases/show-document-model';
const { mapActions } = createNamespacedHelpers('CasesModule');
import DegreeColorPalette from '../degree-color-palette';

export default {
  name: 'CaseDocumentsTab',
  components: {
    DocumentCard,
    ShowDocumentsModel,
    DegreeColorPalette,
  },
  props: {
    caseObjectKey: {
      type: String,
      required: true,
    },
    isPega: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      loading: false,
      selectedDocumentIndex: 0,
      showDocumentsInfoModal: false,
      showAlertModal: false,
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    ...mapActions([
      'getCaseDocuments',
    ]),
    loadData() {
      const params = {
        objectKey: this.caseObjectKey,
        isPega: this.isPega == 'true',
      };
      this.loading = true;
      this.getCaseDocuments(params)
        .then((res) => {
          this.documents = res.data;
        })
        .catch(err => this.toaster.error(err.message))
        .finally(() => (this.loading = false));
    },
    openDocumentsInfo(document) {
      this.showDocumentsInfoModal = true;
      this.selectedDocumentIndex = this.documents.findIndex(a => a.spid == document.spid);
    },
    closeDocumentsInfo() {
      this.showDocumentsInfoModal = false;
      this.selectedDocumentIndex = 0;
    },

  },
};

</script>

<style lang="scss" scoped>
</style>